import { isMobile } from "../../helpers/helpers";
import Headline from "../../components/Title/Headlines";
import CONSTANTS from "../../Constants";
import './SummaryPage.scss'
import StickyButton from "../../components/Forms/StickyButton";
import { useState, useEffect } from "react";
import Quote from "../../components/QuoteContent/Quote";
import { useSelector, useDispatch } from "react-redux";
import { setDealerDetails, setSelectedPremiumServicesToStore, setPersonalInformations } from "../../redux-files/actions/action";
import { Link, useNavigate } from "react-router-dom";
import fetchApiData from "../../apiHandlers/fetchApiData";
import ContentLoader from 'react-content-loader';
import useBodyClass from "../../custom-Hooks/useBodyClass";
import useScrollTop from "../../custom-Hooks/useScrollTop";
import { pushToGTMTracker, pushEventToGTM } from "../../helpers/trackerManager";

const SummaryPage = () => {
    const dealer = useSelector(state => state.ndel_store.dealer)
    const appointmentInfo = useSelector(state => state.ndel_store.appointment)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const personalInfos = useSelector(state => state.ndel_store.personalInfos)
    const isFromLink = useSelector(state => state.ndel_store.isFromLink)
    const storeSelectedPremiumServicesIdGroupe = useSelector(state => state.ndel_store.selectedPremiumServices)
    const selectedMileageSteps = useSelector(state => state.ndel_store.selectedMileageSteps)
    const listPremiumServices = useSelector(state => state.ndel_store.listPremiumServices)
    const selectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const basketId = useSelector(state => state.ndel_store.basketId)
    const selectedForfaits = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryAdditionalForfaits = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const [additionalInfo, setAdditionalInfo] = useState(personalInfos.comment || '')
    const [selectedPremiumServices, setSelectedPremiumServices] = useState([])
    const [showPlaceHolder, setShowPlaceHolder] = useState(false)
    const [showContinueLinkDealer, setShowContinueLinkDealer] = useState(false)
    const [showContinueLinkAppointment, setShowContinueLinkAppointment] = useState(false)
    const [showContinueLinkVehicle, setShowContinueLinkVehicle] = useState(false)
    const [showCommentSpecialChar, setShowCommentSpecialChar] = useState(false);
    const [contactMode, setContactMode] = useState('')
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const iconLink = "http://rendezvousenligne.peugeot.fr/v2-assets/static/media/ap-mini-pin.png"
    const vehicleIdentificationClass = vehicleInfo.Registration ? 'registration' : (vehicleInfo.SerialNumber ? 'vin' : '')
    useScrollTop()
    useEffect(() => {
        console.log('useEffect run SummaryPage ...')
        let selectedPsFiltred = []
        storeSelectedPremiumServicesIdGroupe.forEach(prService => {
            listPremiumServices.forEach(element => {
                if (prService.idServicePremium === element.idServicePremium) {
                    selectedPsFiltred = [...selectedPsFiltred, element]
                };
            })
        }
        )
        personalInfos.mobilityService && selectedPsFiltred.unshift({ "idServicePremium": -1, "groupe": "mobility", "titre": CONSTANTS.LABELS.userinfos_options_mobility_title, "Price": CONSTANTS.LABELS.userinfos_options_mobility_price })
        setSelectedPremiumServices(selectedPsFiltred)
        switch (personalInfos.contactTypes) {
            case [CONSTANTS.LABELS.userinfos_tel]:
                setContactMode(CONSTANTS.LABELS.userinfos_tel)
                break;
            case [CONSTANTS.LABELS.userinfos_sms]:
                setContactMode(CONSTANTS.LABELS.userinfos_sms)
                break;
            case [CONSTANTS.LABELS.userinfos_email]:
                setContactMode(CONSTANTS.LABELS.userinfos_email)
                break;

            default:
                break;
        }
        pushToGTMTracker('summary-page', window.siteConfig.v2recapitulatif.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)
    }, [])
    const removePremiumService = (slectedPS) => {
        if (slectedPS.idServicePremium === -1) {
            console.log(slectedPS)
            dispatch(setPersonalInformations({ ...personalInfos, mobilityService: false, }))
        }
        setSelectedPremiumServices(selectedPremiumServices.filter(prService => prService.idServicePremium !== slectedPS.idServicePremium))
        dispatch(setSelectedPremiumServicesToStore(storeSelectedPremiumServicesIdGroupe.filter(prService => prService.idServicePremium !== slectedPS.idServicePremium)))
    }
    const confirmRdv = () => {
        setShowPlaceHolder(true)
        let selectedForfaitsCodes = [];
        let selectedFamiliesCodes = []
        const ForfaitsCodes = selectedForfaits.map(forfait => {
            selectedFamiliesCodes.push(forfait.forfaitFamilyCode)
            return forfait.Items[0].Ref
        })
        const OpeartionsCodes = selectedMandatoryAdditionalForfaits.map(mandAddiOperation => {
            return mandAddiOperation.Items[0].Ref
        })
        selectedForfaitsCodes = [...ForfaitsCodes, ...OpeartionsCodes]

        // selectedOperations.forEach((operation, ffkey) => {
        //     console.log(operation)
        //     console.log(operation.forfaits)
        //     operation.forfaits != null && !!Object.values(operation.forfaits) &&
        //         Object.values(operation.forfaits).forEach((forfait, fkey) => {

        //             !!Object.values(forfait.SubFunctionList).length &&
        //                 forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {

        //                     if (forfaitItem.isSelected) {
        //                         selectedServicesCodes.push(forfaitItem.Items[0].Ref);
        //                         selectedFamiliesCodes.push(forfait.Code);
        //                     }
        //                     forfaitItem.Operations && forfaitItem.Operations.forEach((operation, OpKey) => {
        //                         if (operation.isSelected) {
        //                             selectedServicesCodes.push(operation.Items[0].Ref);
        //                             selectedFamiliesCodes.push(forfait.Code);
        //                         }
        //                     });
        //                 });
        //         });
        // });

        const listeInterventions = selectedOperations.map(item => {
            return { "InterventionId": item.interventionId, "interventionLabel": item.interventionLabel };
        });
        const ConfirmRdvAPI = new fetchApiData()
        ConfirmRdvAPI.confirmeRDVBasket({
            "carDetails": { ...vehicleInfo },
            "bookingDetail": { ...appointmentInfo },
            "personalInfos": { ...personalInfos },
            "dealerInfos": { ...dealer },
            "selectedServices": {
                "comment": "",//we need to add this
                "subFunctionCodes": { ...selectedFamiliesCodes },
                "forfaitRefs": { ...selectedForfaitsCodes },
            },
            "listeServicePremium": [...storeSelectedPremiumServicesIdGroupe],
            "listeInterventions": [],
            "idRdv": basketId,
            "AttachmentID": "",//we need to add this
            "isFromLink": isFromLink
        }, selectedMileageSteps.key, CONSTANTS.SITE_CONFIG.idRdvLeads).then(
            data => {
                if (data.d.ErrorCode === 0) {
                    navigate(CONSTANTS.SITE_ROUTS.CONFIRMATION)
                    pushEventToGTM({
                        pageName: 'summary',
                        eventAction: 'Redirection::Internal::Next_step',
                        eventLabel: CONSTANTS.LABELS.summary_confirmrdv,
                        eventCategory: 'Content'
                    })
                } else {
                    setShowPlaceHolder(false);
                }

            })
            .catch(error => {
                console.log('Error: ', error);
                setShowPlaceHolder(false);
            });

    }
    useBodyClass('page-summary')
    return (
        !showPlaceHolder ? <>
            {!isMobile() && <Headline
                Title={CONSTANTS.LABELS.summary_title}
                SubTitle={CONSTANTS.LABELS.summary_quote_subtitle}
            />}
            <div className='summary-wrapper'>
                <div className='summary-content'>
                    <div className='cl-1'>
                        <TabComponent tabTilte={CONSTANTS.LABELS.header_quote_ariane3}>{/*your quote*/}
                            <Quote
                                title={CONSTANTS.LABELS.header_quote_ariane2}
                                isSummaryPage={true}
                            >
                                <div className='row'>
                                    <div tabIndex='0' className='content-title'>
                                        {`${CONSTANTS.LABELS.summary_premium_options} (${selectedPremiumServices.length})`}
                                    </div>
                                    <Link
                                        to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                                        onClick={() => pushEventToGTM({
                                            pageName: 'summary',
                                            eventAction: 'Redirection::Internal::PersonalInformations',
                                            eventLabel: CONSTANTS.LABELS.quote_add_option,
                                            eventCategory: 'Content'
                                        })}
                                        className='icons plus-icon addOperation-link'>
                                        {CONSTANTS.LABELS.quote_add_option}
                                    </Link>
                                </div>
                                {selectedPremiumServices.map(slectedPS => {
                                    return (
                                        <div className='op-block'>
                                            <div className="op-title">
                                                {slectedPS.titre}
                                            </div>
                                            <i className={`trash-icon`} onClick={() => removePremiumService(slectedPS)} />
                                        </div>
                                    )
                                })}
                            </Quote>
                        </TabComponent>
                        <TabComponent tabTilte={CONSTANTS.LABELS.header_quote_ariane5}>{/*personal information*/}
                            <div className='personal_info-summary-block'>
                                <h1 tabIndex='0' className='customer-name'>
                                    {personalInfos.civility === "Common_Sir"
                                        ? `${CONSTANTS.LABELS.userinfos_mister} `
                                        : personalInfos.civility === "Common_Madam"
                                        ? `${CONSTANTS.LABELS.userinfos_madam} `
                                        : `${CONSTANTS.LABELS.userinfos_neutral} `
                                        }{`${personalInfos.firstName} ${personalInfos.lastName}`}
                                </h1>
                                <div className='infos-wrapper'>
                                    <div className='block-content'>
                                        {!isMobile() && <div tabIndex='0' className='title'>
                                            {CONSTANTS.LABELS.userinfos_email}
                                        </div>}
                                        <div tabIndex='0' className='content email'>
                                            {personalInfos.email}
                                        </div>
                                    </div>
                                    <div className='block-content'>
                                        {!isMobile() && <div tabIndex='0' className='title'>
                                            {CONSTANTS.LABELS.userinfos_tel}
                                        </div>}
                                        <div tabIndex='0' className='content phone'>
                                            {personalInfos.phone}
                                        </div>
                                    </div>
                                    <div className='block-content'>
                                        {!isMobile() && <>
                                            <div tabIndex='0' className='title'>
                                                {CONSTANTS.LABELS.summary_userinfos_contact_mode}
                                            </div>
                                            <div tabIndex='0' className='content contact_type' >
                                                {contactMode}
                                            </div>
                                        </>}
                                    </div>
                                </div>
                                <Link to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                                    className='edit-link'
                                    onClick={() => {
                                        pushEventToGTM({
                                            pageName: 'summary',
                                            eventAction: 'Redirection::Internal::PersonalInformations',
                                            eventLabel: CONSTANTS.LABELS.common_v2_modify,
                                            eventCategory: 'Content'
                                        })
                                    }}
                                >
                                    {CONSTANTS.LABELS.common_v2_modify}
                                </Link>
                            </div>
                        </TabComponent>
                        <TabComponent tabTilte={CONSTANTS.LABELS.summary_comment}>{/*additionnal information*/}
                            <div className='additional_info-summary-block'>
                                <textarea 
                                    maxLength={500}
                                    onChange={e => {
                                        if (
                                          e.target.value.match(
                                            /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                                          )
                                        )
                                          setShowCommentSpecialChar(true);
                                        else {
                                          setAdditionalInfo(e.target.value);
                                          dispatch(
                                            setPersonalInformations({
                                              ...personalInfos,
                                              comment: e.target.value,
                                            })
                                          );
                                          setShowCommentSpecialChar(false);
                                        } 
                                        }}
                                    rows="4"
                                    cols="120"
                                    name="commentsupp"
                                    role="textbox"
                                    value={additionalInfo}>
                                </textarea>
                                <div className='length-text'>{`(${additionalInfo.length}/500${CONSTANTS.LABELS.summary_comment_label1})`}</div>
                                {showCommentSpecialChar && <div style={{ color: "red" }}>{CONSTANTS.LABELS.userinfos_error_name_special_char}</div>}
                            </div>
                        </TabComponent>
                    </div>
                    <div className='cl-1'>
                        <TabComponent tabTilte={CONSTANTS.LABELS.header_quote_ariane4}>{/*your appointment*/}
                            <div className='appointment-summary-block'>

                                <div className='adress-block'>
                                    <h1 tabIndex='0' className='dealer-name'>{dealer.name}</h1>
                                    {!isMobile() && <div tabIndex='0' className='title'>{CONSTANTS.LABELS.summary_appointment_address}</div>}
                                    <div tabIndex='0' className='adress'>{`${dealer.adress} ${dealer.zip} ${dealer.city}`}</div>
                                    {!showContinueLinkDealer && <div className='edit-link' tabIndex='0' role="button" onClick={() => setShowContinueLinkDealer(true)}>{CONSTANTS.LABELS.common_v2_modify}</div>}
                                    {showContinueLinkDealer && <>
                                        <Link
                                            to={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE}
                                            className='edit-link'
                                            onClick={() => {
                                                dispatch(setDealerDetails({
                                                    ...dealer,
                                                    editDealer: true
                                                }))
                                                pushEventToGTM({
                                                    pageName: 'summary',
                                                    eventAction: 'Redirection::Internal::Services',
                                                    eventLabel: CONSTANTS.LABELS.summary_warning1_continue,
                                                    eventCategory: 'Content'
                                                })
                                            }}>
                                            {CONSTANTS.LABELS.summary_warning1_continue}
                                        </Link>
                                        <div tabIndex='0' className='alert-info'>{CONSTANTS.LABELS.summary_warning_alert_dealer}</div>
                                    </>
                                    }

                                </div>

                                {dealer.position && <div className="dealerInfos-map">
                                    <img className="dealer-map" alt="dealer-map"
                                        src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=${(window.innerWidth < 800 ? (window.innerWidth - 60) : 170)}x170&maptype=roadmap&markers=icon:${iconLink}|${dealer.position.lat},${dealer.position.lng}&key=${CONSTANTS.SITE_INFO.GOOGLE_MAP_API_KEY}`}
                                    />
                                    <a rel="noopener noreferrer" href={`https://www.google.com/maps/dir//${dealer.position.lat},${dealer.position.lng}/@${dealer.position.lat},${dealer.position.lng},13z`}
                                        className="linkto"
                                        target="_blank"
                                        onClick={() => {
                                            // pushEventToGTM({
                                            //     pageName: 'summary',
                                            //     eventAction: 'Redirection::External::Map',
                                            //     eventLabel: CONSTANTS.LABELS.summary_appointment_togooglemap
                                            // });
                                        }}
                                    >
                                        <span>{CONSTANTS.LABELS.summary_appointment_togooglemap}</span>
                                    </a>
                                </div>}

                                <div className='appointment-block'>
                                    <div className='row'>
                                        <div className='date-col'>
                                            {!isMobile() && <div tabIndex='0' className='row-name'>{CONSTANTS.LABELS.summary_appointment_date}</div>}
                                            <div tabIndex='0' className='row-date-value'>  {appointmentInfo.dayDate}  </div>
                                        </div>
                                        <div className='slot-col'>
                                            {!isMobile() && <div tabIndex='0' className='row-name'>{CONSTANTS.LABELS.summary_appointment_hour}</div>}
                                            <div tabIndex='0' className='row-slot-value'> {appointmentInfo.hour} </div>
                                        </div>
                                    </div>
                                    {!showContinueLinkAppointment && <div className='edit-link' tabIndex='0' role="button" onClick={() => setShowContinueLinkAppointment(true)}>{CONSTANTS.LABELS.common_v2_modify}</div>}
                                    {showContinueLinkAppointment && <>
                                        <Link to={CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE}
                                            className={`edit-link `}
                                            onClick={pushEventToGTM({
                                                pageName: 'summary',
                                                eventAction: 'Redirection::Internal::Appointment',
                                                eventLabel: CONSTANTS.LABELS.summary_warning1_continue,
                                                eventCategory: 'Content'
                                            })}
                                        >
                                            {CONSTANTS.LABELS.summary_warning1_continue}
                                        </Link>
                                        <div tabIndex='0' className='alert-info'>{CONSTANTS.LABELS.summary_warning_alert_slot}</div>
                                    </>}
                                </div>
                            </div>

                        </TabComponent>
                        <TabComponent tabTilte={CONSTANTS.LABELS.header_quote_ariane1}>{/*your vehicle*/}
                            <div className='vehicle-summary-block'>
                                <h1 tabIndex='0' className='vehicle-name'>{`${vehicleInfo.ModelLabel} ${vehicleInfo.EnergyLabel}`}</h1>
                                <div className='infos-wrapper'>
                                    <div className='block-content'>
                                        {!isMobile() && <div tabIndex='0' className='title'>
                                            {vehicleInfo.SerialNumber ? CONSTANTS.LABELS.header_modification_vin : CONSTANTS.LABELS.header_modification_immat}
                                        </div>}
                                        <div tabIndex='0' className={`content ${vehicleIdentificationClass}`}>
                                            {vehicleInfo.Registration || vehicleInfo.SerialNumber || '-'}
                                        </div>
                                    </div>
                                    <div className='block-content'>
                                        {!isMobile() && <div tabIndex='0' className='title'>
                                            {CONSTANTS.LABELS.header_modification_km}
                                        </div>}
                                        <div tabIndex='0' className=' content mileage' >
                                            {vehicleInfo.Mileage} Miles
                                    </div>
                                    </div>
                                    <div className='block-content'>
                                        {!isMobile() && <div tabIndex='0' className='title'>
                                            {CONSTANTS.LABELS.account_warranty}
                                        </div>}
                                        <div tabIndex='0' className='content service'>
                                            {vehicleInfo.contratService ? CONSTANTS.LABELS.summary_vehicule_warranty_true : CONSTANTS.LABELS.summary_vehicule_warranty_false}
                                        </div>
                                    </div>
                                </div>
                                {!showContinueLinkVehicle && <div className='edit-link' tabIndex='0' role="button" onClick={() => setShowContinueLinkVehicle(true)}>{CONSTANTS.LABELS.common_v2_modify}</div>}
                                {showContinueLinkVehicle && <>
                                    <Link to={CONSTANTS.SITE_ROUTS.VEHICLEPAGE}
                                        className='edit-link'
                                        onClick={() => pushEventToGTM({
                                            pageName: 'summary',
                                            eventAction: 'Redirection::Internal::CarDetails',
                                            eventLabel: CONSTANTS.LABELS.summary_warning1_continue,
                                            eventCategory: 'Content'
                                        })}
                                    >
                                        {CONSTANTS.LABELS.summary_warning1_continue}
                                    </Link>
                                    <div tabIndex='0' className='alert-info'>{CONSTANTS.LABELS.summary_warning_alert_vehicle}</div>
                                </>}
                            </div>
                        </TabComponent>
                    </div>
                </div>

            </div>
            <StickyButton
                label={CONSTANTS.LABELS.summary_confirmrdv}
                isDisabled={false}
                handleClick={confirmRdv}
            />
        </> :
            <ContentLoader preserveAspectRatio="none" >
                <rect x="215" y="30" width="140" height="10"></rect>
                <rect x="215" y="42" width="140" height="30"></rect>
                <rect x="65" y="60" width="140" height="10"></rect>
                <rect x="65" y="75" width="140" height="5"></rect>
                <rect x="70%" y="85" width="50" height="10"></rect>
                <rect x="150" y="10" width="100" height="5"></rect>
                <rect x="150" y="18" width="100" height="3"></rect>
            </ContentLoader>
    );
}

const TabComponent = (props) => {
    const [isTabOpen, setIsTabOpen] = useState(true)
    const isTabOpenClass = isTabOpen ? 'open' : 'close'

    return (
        <>
            <div className='tab-summary'>
                <h1 tabIndex='0' className={`tab-title ${isTabOpenClass}`} onClick={() => setIsTabOpen(!isTabOpen)} onKeyDown = {(e)=> e.key === 'Enter' && setIsTabOpen(!isTabOpen)}>{props.tabTilte}</h1>
            </div>
            {isTabOpen && <div className='summary-block'>
                {props.children}
            </div>}
        </>
    );
}
export default SummaryPage;